import { EventAutocomplete as FormEventAutocomplete } from '../../forms/inputs/event-autocomplete';
import { EventAutocomplete } from '../update-to-event/types';

export const EventAutocompleteComponent: EventAutocomplete = (props) => {
    return <FormEventAutocomplete {...props} defaultValue={null} />;
};
